<template>
  <el-input
    v-model="inputValue"
    :class="['search-input-box', size]"
    type="text"
    :placeholder="placeholder"
    :name="name"
    @input="handleChange"
  >
    <template #prefix>
      <img src="../assets/icons/Magnifier.svg" alt="" />
    </template>
  </el-input>
</template>

<script lang="ts">
import debounce from 'lodash/debounce'

export default {
  name: 'SearchBox',
  props: {
    name: { type: String, default: null },
    placeholder: { type: String, default: null },
    onChange: { type: Function },
    size: { type: String, default: 'regular' },
  },
  data() {
    return {
      inputValue: '',
    }
  },
  methods: {
    handleChange(value) {
      if (this.onChange) {
        this.debouncedOnChange(value, this.onChange)
      }
    },
    debouncedOnChange: debounce((searchQuery, onChange) => {
      if (searchQuery.length > 1 || !searchQuery.length) {
        onChange(searchQuery)
      }
    }, 500),
  },
}
</script>
<style scoped lang="scss">
.large {
  height: 54px;
}
</style>
